<template>
  <div ref="trapRef" class="modal ">
    <div @click="$emit('closeModal')" class="modal-background"></div>
    <div class="modal-card-intro-video">  
    <q-video tabindex="0"
      :ratio="800 / 472"

      src="https://cdnapisec.kaltura.com/p/1128062/sp/112806200/embedIframeJs/uiconf_id/27474902/partner_id/1128062?iframeembed=true&playerId=kaltura_player&entry_id=1_432k1v6a&flashvars[akamaiHD.loadingPolicy]=preInitialize&amp;flashvars[akamaiHD.asyncInit]=true&amp;flashvars[streamerType]=hdnetwork&amp;flashvars[localizationCode]=en&amp;flashvars[hotspots.plugin]=1&amp;flashvars[Kaltura.addCrossoriginToIframe]=true&amp;&wid=1_0hnl5k5m" width="800" height="529" allowfullscreen webkitallowfullscreen mozAllowFullScreen allow="autoplay *; fullscreen *; encrypted-media *" sandbox="allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation" frameborder="0" title="Undergraduate Degree
Classification Calculator"
    />
   
      <div class="mts mc">
        <!-- <button class="button is-success">Save changes</button> -->
        <button aria-label="close"  @click="$emit('closeModal')" class="button mts">Close</button>
      </div>
    </div>
  </div>
</template>


<script>
import useFocusTrap from "@/composables/useFocusTrap";

export default {

  props: ['contents'],
  setup(props, { emit }) {

    const { trapRef } = useFocusTrap();

    const modalThing = () => {
      emit('closeModal')
    }

    return { modalThing, trapRef }

  }

}
</script>



<style scoped>

</style>